// Ideas offered under the start box, a few at a time, for anyone unsure what to ask
// for. Labels stay short; where three don't fit on one row, two are shown.
export const EXAMPLES = [
  { label: "Bedtime story", prompt: "Bedtime story for my children" },
  { label: "Dinner ideas", prompt: "List of dinner ideas for the week" },
  { label: "Reply to my boss", prompt: "Response to my boss" },
  { label: "Birthday card", prompt: "Birthday card message for my mum" },
  { label: "Cover letter", prompt: "Cover letter for a job application" },
  {
    label: "Best man speech",
    prompt: "Best man speech for my brother's wedding",
  },
  { label: "Packing list", prompt: "Packing list for a week's beach holiday" },
  { label: "Weekly budget", prompt: "Weekly household budget spreadsheet" },
  { label: "Workout plan", prompt: "Four-week beginner workout plan" },
  { label: "Thank-you note", prompt: "Thank-you note to my child's teacher" },
  { label: "Lost cat poster", prompt: "Poster for a lost cat" },
  {
    label: "Complaint letter",
    prompt: "Complaint letter about a late delivery",
  },
  { label: "Party invite", prompt: "Invitation to my 30th birthday party" },
  { label: "Exam timetable", prompt: "Revision timetable for my exams" },
  { label: "Pitch deck", prompt: "Pitch deck for a small coffee shop" },
  { label: "Funny poem", prompt: "Funny poem about Mondays" },
  { label: "Off sick email", prompt: "Email telling work I'm off sick today" },
  {
    label: "Shopping list",
    prompt: "Shopping list for a week of healthy meals",
  },
  { label: "Veg garden plan", prompt: "Plan for a small vegetable garden" },
  {
    label: "Product blurb",
    prompt: "Product description for handmade candles",
  },
  { label: "Out of office", prompt: "Out-of-office email reply" },
  { label: "Resignation", prompt: "Resignation letter" },
  { label: "Road trip", prompt: "Three-day road trip itinerary" },
  { label: "Pub quiz", prompt: "Pub quiz with 20 questions and answers" },
  {
    label: "Landlord letter",
    prompt: "Letter asking my landlord to fix the boiler",
  },
  { label: "Dog walking ad", prompt: "Advert for my dog walking business" },
  { label: "Gift ideas", prompt: "Christmas gift ideas for my dad" },
  { label: "Rainy day fun", prompt: "Rainy day activities for kids" },
  { label: "Quick curry", prompt: "Recipe for a quick vegan curry" },
  { label: "Say sorry", prompt: "Apology message to a friend" },
  { label: "Chore chart", prompt: "Weekly chore chart for the family" },
  { label: "Meeting agenda", prompt: "Agenda for a team meeting" },
  { label: "LinkedIn post", prompt: "LinkedIn post about my new job" },
  { label: "Retirement card", prompt: "Retirement message for a colleague" },
  {
    label: "Dragon story",
    prompt: "Short story about a dragon who's afraid of fire",
  },
  { label: "Bakery logo", prompt: "Logo for a bakery called Rise" },
  { label: "Rome trip", prompt: "Five days in Rome itinerary" },
  { label: "Neighbour note", prompt: "Friendly note to my noisy neighbours" },
  { label: "Revision notes", prompt: "Revision notes on the water cycle" },
  { label: "Pop song", prompt: "Pop song about summer love" },
  { label: "Invoice", prompt: "Invoice for freelance design work" },
  { label: "Business plan", prompt: "One-page business plan for a food truck" },
  { label: "Job advert", prompt: "Job advert for a part-time barista" },
  {
    label: "Photo captions",
    prompt: "Instagram captions for my holiday photos",
  },
  { label: "Graduation speech", prompt: "Speech for my daughter's graduation" },
  { label: "Wedding vows", prompt: "Wedding vows" },
  { label: "Cleaning rota", prompt: "Cleaning rota for a shared house" },
  {
    label: "Reference letter",
    prompt: "Reference letter for a former employee",
  },
  { label: "Book club", prompt: "Discussion questions for my book club" },
  { label: "Fantasy map", prompt: "Map of a fantasy island" },
];

// A few different examples, freshly picked each time
export function pickExamples(count = 3, from = EXAMPLES) {
  const pool = [...from];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, count);
}
